import ActionTypes from '../constants/ActionTypes';

export const setSlugToPlay = payload => ({
  type: ActionTypes.SET_CURRENTLY_PLAYING_AUDIO_PROLEM_SLUG,
  payload,
});

export const setAudioCount = payload => ({
  type: ActionTypes.SET_AUDIO_PLAY_COUNT,
  payload,
});

export const createOrUpdateAudioSolution = (
  solution,
  problemSlug,
  solutionSlug,
  retryCallback
) => ({
  type: ActionTypes.CREATE_OR_UPDATE_AUDIO_SOLUTION,
  problemSlug,
  solution,
  solutionSlug,
  retryCallback,
});

export const updateAudioUploadStatus = (problemSlug, status) => ({
  type: ActionTypes.SET_AUDIO_UPLOAD_STATUS,
  isAudioUploadInProgress: status,
  problemSlug,
});

export const updateSlugChangeFromRouter = value => ({
  type: ActionTypes.SLUG_CHANGE_FROM_ROUTER,
  slugChangeFromRouter: value,
});
